module.exports = __webpack_public_path__ + "img/2-22.5986a1a1.jpg";